import { render, staticRenderFns } from "./ProfileSecurityQuestionsTab.vue?vue&type=template&id=257c08aa"
import script from "./ProfileSecurityQuestionsTab.vue?vue&type=script&lang=js"
export * from "./ProfileSecurityQuestionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports